import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Page3 = ({ sectionStyle }) => {
  const navigate = useNavigate();
  return (
    <div
      style={{ ...sectionStyle, gap: "85px", position: "relative" }}
      className="d-flex flex-column justify-content-end align-items-center py-4"
    >
      <div
        className="w-100 d-flex flex-column align-items-center mb-5"
        style={{ position: "relative" }}
      >
        <svg
          width="1240"
          height="320"
          viewBox="0 0 1240 320"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_152_231)">
            <rect width="1240" height="320" rx="40" fill="#0D8ED1" />
            <g opacity="0.5" filter="url(#filter0_f_152_231)">
              <circle cx="176.5" cy="482.5" r="108.5" fill="#005FDA" />
            </g>
            <g opacity="0.5" filter="url(#filter1_f_152_231)">
              <circle cx="1060.5" cy="22.5" r="108.5" fill="#005FDA" />
            </g>
            <g opacity="0.6" clip-path="url(#clip1_152_231)">
              <g mask="url(#mask0_152_231)">
                <g clip-path="url(#clip2_152_231)">
                  <path
                    d="M51 96V97H52V96H51ZM51 0H50V96H51H52V0H51ZM51 96V95H-45V96V97H51V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-6-inside-1_152_231)"
                  />
                  <path
                    d="M147 96V97H148V96H147ZM147 0H146V96H147H148V0H147ZM147 96V95H51V96V97H147V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-8-inside-2_152_231)"
                  />
                  <path
                    d="M243 96V97H244V96H243ZM243 0H242V96H243H244V0H243ZM243 96V95H147V96V97H243V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-10-inside-3_152_231)"
                  />
                  <path
                    d="M339 96V97H340V96H339ZM339 0H338V96H339H340V0H339ZM339 96V95H243V96V97H339V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-12-inside-4_152_231)"
                  />
                  <path
                    d="M435 96V97H436V96H435ZM435 0H434V96H435H436V0H435ZM435 96V95H339V96V97H435V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-14-inside-5_152_231)"
                  />
                  <path
                    d="M531 96V97H532V96H531ZM531 0H530V96H531H532V0H531ZM531 96V95H435V96V97H531V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-16-inside-6_152_231)"
                  />
                  <path
                    d="M627 96V97H628V96H627ZM627 0H626V96H627H628V0H627ZM627 96V95H531V96V97H627V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-18-inside-7_152_231)"
                  />
                  <path
                    d="M723 96V97H724V96H723ZM723 0H722V96H723H724V0H723ZM723 96V95H627V96V97H723V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-20-inside-8_152_231)"
                  />
                  <path
                    d="M819 96V97H820V96H819ZM819 0H818V96H819H820V0H819ZM819 96V95H723V96V97H819V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-22-inside-9_152_231)"
                  />
                  <path
                    d="M915 96V97H916V96H915ZM915 0H914V96H915H916V0H915ZM915 96V95H819V96V97H915V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-24-inside-10_152_231)"
                  />
                  <path
                    d="M1011 96V97H1012V96H1011ZM1011 0H1010V96H1011H1012V0H1011ZM1011 96V95H915V96V97H1011V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-26-inside-11_152_231)"
                  />
                  <path
                    d="M1107 96V97H1108V96H1107ZM1107 0H1106V96H1107H1108V0H1107ZM1107 96V95H1011V96V97H1107V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-28-inside-12_152_231)"
                  />
                  <path
                    d="M1203 96V97H1204V96H1203ZM1203 0H1202V96H1203H1204V0H1203ZM1203 96V95H1107V96V97H1203V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-30-inside-13_152_231)"
                  />
                  <path
                    d="M1299 96V97H1300V96H1299ZM1299 0H1298V96H1299H1300V0H1299ZM1299 96V95H1203V96V97H1299V96Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-32-inside-14_152_231)"
                  />
                  <path
                    d="M51 192V193H52V192H51ZM51 96H50V192H51H52V96H51ZM51 192V191H-45V192V193H51V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-34-inside-15_152_231)"
                  />
                  <path
                    d="M147 192V193H148V192H147ZM147 96H146V192H147H148V96H147ZM147 192V191H51V192V193H147V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-36-inside-16_152_231)"
                  />
                  <path
                    d="M147 96H243V192H147V96Z"
                    fill="#F2F4F7"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M243 192V193H244V192H243ZM243 96H242V192H243H244V96H243ZM243 192V191H147V192V193H243V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-38-inside-17_152_231)"
                  />
                  <path
                    d="M339 192V193H340V192H339ZM339 96H338V192H339H340V96H339ZM339 192V191H243V192V193H339V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-40-inside-18_152_231)"
                  />
                  <path
                    d="M435 192V193H436V192H435ZM435 96H434V192H435H436V96H435ZM435 192V191H339V192V193H435V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-42-inside-19_152_231)"
                  />
                  <path
                    d="M531 192V193H532V192H531ZM531 96H530V192H531H532V96H531ZM531 192V191H435V192V193H531V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-44-inside-20_152_231)"
                  />
                  <path
                    d="M627 192V193H628V192H627ZM627 96H626V192H627H628V96H627ZM627 192V191H531V192V193H627V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-46-inside-21_152_231)"
                  />
                  <path
                    d="M723 192V193H724V192H723ZM723 96H722V192H723H724V96H723ZM723 192V191H627V192V193H723V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-48-inside-22_152_231)"
                  />
                  <path
                    d="M819 192V193H820V192H819ZM819 96H818V192H819H820V96H819ZM819 192V191H723V192V193H819V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-50-inside-23_152_231)"
                  />
                  <path
                    d="M915 192V193H916V192H915ZM915 96H914V192H915H916V96H915ZM915 192V191H819V192V193H915V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-52-inside-24_152_231)"
                  />
                  <path
                    d="M1011 192V193H1012V192H1011ZM1011 96H1010V192H1011H1012V96H1011ZM1011 192V191H915V192V193H1011V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-54-inside-25_152_231)"
                  />
                  <path
                    d="M1011 96H1107V192H1011V96Z"
                    fill="#F2F4F7"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M1107 192V193H1108V192H1107ZM1107 96H1106V192H1107H1108V96H1107ZM1107 192V191H1011V192V193H1107V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-56-inside-26_152_231)"
                  />
                  <path
                    d="M1203 192V193H1204V192H1203ZM1203 96H1202V192H1203H1204V96H1203ZM1203 192V191H1107V192V193H1203V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-58-inside-27_152_231)"
                  />
                  <path
                    d="M1299 192V193H1300V192H1299ZM1299 96H1298V192H1299H1300V96H1299ZM1299 192V191H1203V192V193H1299V192Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-60-inside-28_152_231)"
                  />
                  <path
                    d="M51 288V289H52V288H51ZM51 192H50V288H51H52V192H51ZM51 288V287H-45V288V289H51V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-62-inside-29_152_231)"
                  />
                  <path
                    d="M147 288V289H148V288H147ZM147 192H146V288H147H148V192H147ZM147 288V287H51V288V289H147V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-64-inside-30_152_231)"
                  />
                  <path
                    d="M243 288V289H244V288H243ZM243 192H242V288H243H244V192H243ZM243 288V287H147V288V289H243V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-66-inside-31_152_231)"
                  />
                  <path
                    d="M339 288V289H340V288H339ZM339 192H338V288H339H340V192H339ZM339 288V287H243V288V289H339V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-68-inside-32_152_231)"
                  />
                  <path
                    d="M339 192H435V288H339V192Z"
                    fill="#F2F4F7"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M435 288V289H436V288H435ZM435 192H434V288H435H436V192H435ZM435 288V287H339V288V289H435V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-70-inside-33_152_231)"
                  />
                  <path
                    d="M531 288V289H532V288H531ZM531 192H530V288H531H532V192H531ZM531 288V287H435V288V289H531V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-72-inside-34_152_231)"
                  />
                  <path
                    d="M627 288V289H628V288H627ZM627 192H626V288H627H628V192H627ZM627 288V287H531V288V289H627V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-74-inside-35_152_231)"
                  />
                  <path
                    d="M723 288V289H724V288H723ZM723 192H722V288H723H724V192H723ZM723 288V287H627V288V289H723V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-76-inside-36_152_231)"
                  />
                  <path
                    d="M723 192H819V288H723V192Z"
                    fill="#F2F4F7"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M819 288V289H820V288H819ZM819 192H818V288H819H820V192H819ZM819 288V287H723V288V289H819V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-78-inside-37_152_231)"
                  />
                  <path
                    d="M915 288V289H916V288H915ZM915 192H914V288H915H916V192H915ZM915 288V287H819V288V289H915V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-80-inside-38_152_231)"
                  />
                  <path
                    d="M1011 288V289H1012V288H1011ZM1011 192H1010V288H1011H1012V192H1011ZM1011 288V287H915V288V289H1011V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-82-inside-39_152_231)"
                  />
                  <path
                    d="M1107 288V289H1108V288H1107ZM1107 192H1106V288H1107H1108V192H1107ZM1107 288V287H1011V288V289H1107V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-84-inside-40_152_231)"
                  />
                  <path
                    d="M1203 288V289H1204V288H1203ZM1203 192H1202V288H1203H1204V192H1203ZM1203 288V287H1107V288V289H1203V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-86-inside-41_152_231)"
                  />
                  <path
                    d="M1299 288V289H1300V288H1299ZM1299 192H1298V288H1299H1300V192H1299ZM1299 288V287H1203V288V289H1299V288Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-88-inside-42_152_231)"
                  />
                  <path
                    d="M51 384V385H52V384H51ZM51 288H50V384H51H52V288H51ZM51 384V383H-45V384V385H51V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-90-inside-43_152_231)"
                  />
                  <path
                    d="M147 384V385H148V384H147ZM147 288H146V384H147H148V288H147ZM147 384V383H51V384V385H147V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-92-inside-44_152_231)"
                  />
                  <path
                    d="M243 384V385H244V384H243ZM243 288H242V384H243H244V288H243ZM243 384V383H147V384V385H243V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-94-inside-45_152_231)"
                  />
                  <path
                    d="M339 384V385H340V384H339ZM339 288H338V384H339H340V288H339ZM339 384V383H243V384V385H339V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-96-inside-46_152_231)"
                  />
                  <path
                    d="M435 384V385H436V384H435ZM435 288H434V384H435H436V288H435ZM435 384V383H339V384V385H435V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-98-inside-47_152_231)"
                  />
                  <path
                    d="M531 384V385H532V384H531ZM531 288H530V384H531H532V288H531ZM531 384V383H435V384V385H531V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-100-inside-48_152_231)"
                  />
                  <path
                    d="M627 384V385H628V384H627ZM627 288H626V384H627H628V288H627ZM627 384V383H531V384V385H627V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-102-inside-49_152_231)"
                  />
                  <path
                    d="M723 384V385H724V384H723ZM723 288H722V384H723H724V288H723ZM723 384V383H627V384V385H723V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-104-inside-50_152_231)"
                  />
                  <path
                    d="M819 384V385H820V384H819ZM819 288H818V384H819H820V288H819ZM819 384V383H723V384V385H819V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-106-inside-51_152_231)"
                  />
                  <path
                    d="M915 384V385H916V384H915ZM915 288H914V384H915H916V288H915ZM915 384V383H819V384V385H915V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-108-inside-52_152_231)"
                  />
                  <path
                    d="M1011 384V385H1012V384H1011ZM1011 288H1010V384H1011H1012V288H1011ZM1011 384V383H915V384V385H1011V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-110-inside-53_152_231)"
                  />
                  <path
                    d="M1011 288H1107V384H1011V288Z"
                    fill="#F2F4F7"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M1107 384V385H1108V384H1107ZM1107 288H1106V384H1107H1108V288H1107ZM1107 384V383H1011V384V385H1107V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-112-inside-54_152_231)"
                  />
                  <path
                    d="M1203 384V385H1204V384H1203ZM1203 288H1202V384H1203H1204V288H1203ZM1203 384V383H1107V384V385H1203V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-114-inside-55_152_231)"
                  />
                  <path
                    d="M1299 384V385H1300V384H1299ZM1299 288H1298V384H1299H1300V288H1299ZM1299 384V383H1203V384V385H1299V384Z"
                    fill="#D0D5DD"
                    fill-opacity="0.32"
                    mask="url(#path-116-inside-56_152_231)"
                  />
                </g>
                <rect
                  x="-332.5"
                  y="0.5"
                  width="1919"
                  height="1439"
                  stroke="#D0D5DD"
                  stroke-opacity="0.32"
                />
              </g>
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_152_231"
              x="-332"
              y="-26"
              width="1017"
              height="1017"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="200"
                result="effect1_foregroundBlur_152_231"
              />
            </filter>
            <filter
              id="filter1_f_152_231"
              x="552"
              y="-486"
              width="1017"
              height="1017"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="200"
                result="effect1_foregroundBlur_152_231"
              />
            </filter>
            <filter
              id="filter2_d_152_231"
              x="477.2"
              y="202.2"
              width="294.6"
              height="98.6"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dx="4" dy="11" />
              <feGaussianBlur stdDeviation="11.4" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_152_231"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_152_231"
                result="shape"
              />
            </filter>
            <radialGradient
              id="paint0_radial_152_231"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(720 -0.000142694) rotate(90) scale(1197 751.588)"
            >
              <stop />
              <stop offset="0.953125" stop-opacity="0" />
            </radialGradient>
            <clipPath id="clip0_152_231">
              <rect width="1240" height="320" rx="40" fill="white" />
            </clipPath>
            <clipPath id="clip1_152_231">
              <rect
                width="1247"
                height="480"
                fill="white"
                transform="translate(3)"
              />
            </clipPath>
            <clipPath id="clip2_152_231">
              <rect x="-333" width="1920" height="1440" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div
          style={{
            position: "absolute",
            top: "18%",
            left: "25%",
            width: "50%",
            gap: "10px",
          }}
          className="d-flex flex-column justify-content-center align-items-center text-center"
        >
          <div style={{ fontSize: "48px", fontWeight: "700", color: "white" }}>
            Social Shopping Made Easy
          </div>
          <div
            style={{ fontSize: "18px", fontWeight: "400", color: "#FFFFFFCC" }}
          >
            Enjoy seamless navigation, exclusive content, and personalized
            experiences right at your fingertips. Don't miss out on this
            opportunity to enhance.
          </div>
          <div
            style={{
              marginTop: "18px",
              width: "248px",
              height: "53px",
              backgroundColor: "white",
              color: "#0D8ED1",
              cursor: "pointer",
            }}
            className="d-flex justify-content-center align-items-center rounded-pill"
            onClick={() => navigate("/SignIn")}
          >
            Explore Lookflock
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column align-items-center"
        style={{ gap: "40px" }}
      >
        <div className="w-100 d-flex justify-content-between">
          <div
            style={{ width: "40%", gap: "14px" }}
            className="d-flex flex-column"
          >
            <div
              style={{
                fontFamily: "Nunito Sans",
                fontWeight: "600",
                fontSize: "40px",
                lineHeight: "100%",
                letterSpacing: "0%",
                fontStyle: "italic",
                color: "#676A79",
              }}
            >
              lookflock
            </div>
            <div
              style={{ fontSize: "18px", fontWeight: "400", color: "#676A79" }}
            >
              Lookflock is a social shopping platform where you can discover
              trending outfits, create collaborative shopping lists, and get
              feedback from friends - all in one place!
            </div>
          </div>
          <div
            style={{ width: "40%", gap: "14px" }}
            className="d-flex flex-column"
          >
            <div style={{ fontSize: "20px", fontWeight: "600", color: "#000" }}>
              Company
            </div>
            <div className="d-flex align-items-center" style={{ gap: "48px" }}>
              <Link
                style={{ color: "#676A79" }}
                to="/staticPages/privacyPolicy"
              >
                Privacy Policy
              </Link>
              <Link
                style={{ color: "#676A79" }}
                to="/staticPages/termsAndConditions"
              >
                Terms of Service
              </Link>
              <Link style={{ color: "#676A79" }} to="/staticPages/contactUs">
                Contact Support
              </Link>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", border: "1.5px solid #17171714" }} />
        <div className="d-flex justify-content-between align-items-center w-100">
          <div
            style={{ color: "#676A79", fontSize: "18px", fontWeight: "400" }}
          >
            Copyright © 2025 Lookflock. All Rights Reserved
          </div>
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <svg
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.677734" width="40" height="40" rx="20" fill="white" />
              <path
                d="M21.0859 15.32C21.0859 15.5298 21.0859 16.2136 21.0859 17.1851H24.4261L24.0639 20.1627H21.0859C21.0859 24.7547 21.0859 30.9082 21.0859 30.9082H17.133C17.133 30.9082 17.133 24.8361 17.133 20.1627H15.0732V17.1851H17.133C17.133 16.0043 17.133 15.1646 17.133 14.9308C17.133 13.8169 17.0491 13.2884 17.5224 12.4253C17.9959 11.5621 19.3316 10.4213 21.6418 10.4487C23.9526 10.4772 24.9266 10.6995 24.9266 10.6995L24.4261 13.8729C24.4261 13.8729 22.9505 13.4833 22.2263 13.6221C21.503 13.761 21.0859 14.2066 21.0859 15.32Z"
                fill="#0D8ED1"
              />
            </svg>
            <svg
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.677734" width="40" height="40" rx="20" fill="white" />
              <path
                d="M28.7306 16.1999C28.7393 16.3933 28.7437 16.5876 28.7437 16.7827C28.7437 22.7357 24.2122 29.5997 15.9272 29.5997C13.3831 29.5997 11.015 28.8539 9.02148 27.5757C9.37434 27.6175 9.73245 27.6388 10.0962 27.6388C12.2069 27.6388 14.1489 26.9187 15.6911 25.7102C13.7194 25.6741 12.0562 24.3716 11.4829 22.5819C11.7582 22.6346 12.0401 22.663 12.3306 22.663C12.741 22.663 13.1391 22.6077 13.5173 22.5048C11.4567 22.0909 9.90363 20.2704 9.90363 18.0879C9.90363 18.0687 9.90363 18.05 9.90411 18.0312C10.5114 18.3684 11.2058 18.571 11.9446 18.5945C10.7357 17.7869 9.94067 16.408 9.94067 14.845C9.94067 14.0195 10.1624 13.2458 10.5505 12.5805C12.7723 15.3059 16.091 17.0989 19.8349 17.2871C19.7582 16.9574 19.7181 16.6136 19.7181 16.2604C19.7181 13.7729 21.7351 11.7559 24.2226 11.7559C25.5191 11.7559 26.6892 12.303 27.5108 13.1782C28.5372 12.9765 29.5008 12.6014 30.3712 12.0852C30.0348 13.1373 29.3213 14.0198 28.3908 14.5774C29.3021 14.4685 30.1708 14.2263 30.9784 13.8682C30.3747 14.7714 29.6106 15.5647 28.7306 16.1999Z"
                fill="#0D8ED1"
              />
            </svg>
            <svg
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.677734" width="40" height="40" rx="20" fill="white" />
              <path
                d="M23.8405 11.5107H16.1588C12.8222 11.5107 10.833 13.4999 10.833 16.8366V24.5091C10.833 27.8549 12.8222 29.8441 16.1588 29.8441H23.8313C27.168 29.8441 29.1572 27.8549 29.1572 24.5182V16.8366C29.1663 13.4999 27.1772 11.5107 23.8405 11.5107ZM19.9997 24.2341C18.038 24.2341 16.443 22.6391 16.443 20.6774C16.443 18.7157 18.038 17.1207 19.9997 17.1207C21.9613 17.1207 23.5563 18.7157 23.5563 20.6774C23.5563 22.6391 21.9613 24.2341 19.9997 24.2341ZM25.4263 15.9841C25.3805 16.0941 25.3163 16.1949 25.2338 16.2866C25.1422 16.3691 25.0413 16.4332 24.9313 16.4791C24.8213 16.5249 24.7022 16.5524 24.583 16.5524C24.3355 16.5524 24.1063 16.4607 23.9322 16.2866C23.8497 16.1949 23.7855 16.0941 23.7397 15.9841C23.6938 15.8741 23.6663 15.7549 23.6663 15.6357C23.6663 15.5166 23.6938 15.3974 23.7397 15.2874C23.7855 15.1682 23.8497 15.0766 23.9322 14.9849C24.143 14.7741 24.4638 14.6732 24.7572 14.7374C24.8213 14.7466 24.8763 14.7649 24.9313 14.7924C24.9863 14.8107 25.0413 14.8382 25.0963 14.8749C25.1422 14.9024 25.188 14.9482 25.2338 14.9849C25.3163 15.0766 25.3805 15.1682 25.4263 15.2874C25.4722 15.3974 25.4997 15.5166 25.4997 15.6357C25.4997 15.7549 25.4722 15.8741 25.4263 15.9841Z"
                fill="#0D8ED1"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          height: "55%",
          width: "100%",
          backgroundColor: "#F3F3F3",
          zIndex: "-1",
          bottom: 0,
        }}
      />
    </div>
  );
};

export default Page3;
